<template>
  <div class="data-area">
    <h1>开票信息管理</h1>
    <br>
    <p class="ml20">温馨提示：为保障数据查询效率，最大支持查询还款日期跨度30天的数据</p>
    <br>
    <Row class="tac">
      <Col span="8">
        <span class="label">金票编号：</span>
        <Input placeholder="请输入金票编号" v-model="queryParams.fkCredit" class="input-select"></Input>
      </Col>
      <Col span="8">
        <span class="label">核心企业：</span>
        <Input placeholder="请输入核心企业名称" v-model="queryParams.corpNameCore" class="input-select"></Input>
      </Col>
      <Col span="8">
        <span class="label">融资企业：</span>
        <Input placeholder="请输入融资企业名称" v-model="queryParams.corpName" class="input-select"></Input>
      </Col>
    </Row>
    <br>
    <Row class="tac">
      <Col span="8"> 
        <span class="label">还款日期：</span>
        <DatePicker :value="queryParams.startMaturityDate" type="date" format="yyyy-MM-dd" placeholder="开始" style="width:110px;" @on-change="setDateTime($event, 'startMaturityDate')" :options="beginDateOption"></DatePicker><i class="zhi">-</i>
        <DatePicker :value="queryParams.endMaturityDate" type="date" format="yyyy-MM-dd" placeholder="结束" style="width:110px;" @on-change="setDateTime($event, 'endMaturityDate')" :options="endDateOption"></DatePicker>
      </Col>
      <Col span="8">
        <span class="label">开票状态：</span>
        <Select v-model="queryParams.hasRecord" class="input-select tal" clearable>
          <Option v-for="item in invoiceArr" :value="item.value" :key="item.value">
            {{item.label}}
          </Option>
        </Select>
      </Col>
      <Col span="8">
      </Col>
    </Row>
    <br>
    <Row class="tac">
      <Col span="24">
        <Button type="primary" @click="query(1)">查询</Button>
        <Button class="ml20" @click="queryParams={};query(1);">重置</Button>
      </Col>
    </Row>
    <Row>
      <Col span="12" class="lh-30">
        <span>统计：</span>
        <span class="mr20">待开票笔数：{{unInvoiceRecordCount}}</span>
        <span>待开票金额：{{unInvoiceRecordTotal | currency}}元</span>
      </Col>
      <Col span="12" class="tar">
        <Button type="primary" :loading="exportLoading" @click="exportExcel">导出Excel</Button>
      </Col>
    </Row>
    <Table stripe ref="selection" :columns="columns" :data="data" :loading="loading" @on-selection-change="selectItem" class="mt10"></Table>
    <br>
    <Row>
      <iCol span="8">
        <Checkbox v-model="isCheckedAll" @on-change="selectAll" class="select-all" :disabled="canSelectLength===0">全选</Checkbox>
        <Button type="primary" @click="invoiceAdd" :loading="invoiceLoading" :disabled="selectedItems.length===0">登记开票信息</Button>
      </iCol>
      <iCol span="16" class="tar">
        <Page :total="pagecond.count" :current="pagecond.page" :page-size="pagecond.pageSize" @on-change="changePage"
          @on-page-size-change="changePageSize" show-elevator show-total show-sizer size="small" placement="top">
        </Page>
      </iCol>
    </Row>
    <!-- 开票信息详情弹框 -->
    <Modal v-model="invoiceModal" title="开票信息详情" width="1000" :mask-closable="false">
      <div class="detail-info">
        <Row :gutter="16">
          <Col>
            <h3>融资信息</h3>
            <br>
            <Row>
              <Col span="8">
                <span class="label">金票编号：</span>
                <span class="isblock">{{detailInfo.fkCredit}}</span>
              </Col>
              <Col span="8">
                <span class="label">核心企业：</span>
                <span class="isblock">{{detailInfo.corpNameCore}}</span>
              </Col>
              <Col span="8">
                <span class="label">融资企业：</span>
                <span class="isblock">{{detailInfo.corpNameTransfer}}</span>
              </Col>
            </Row>
            <br>
            <Row>
              <Col span="8">
                <span class="label">金票金额：</span>
                <span class="isblock">{{detailInfo.maturityAmount | currency}}</span>
              </Col>
              <Col span="8">
                <span class="label">融资费用：</span>
                <span class="isblock">{{detailInfo.financeServiceAmount | currency}}</span>
              </Col>
              <Col span="8">
                <span class="label">还款日期：</span>
                <span class="isblock">{{detailInfo.redeemTimeString}}</span>
              </Col>
            </Row>
            <br>
            <h3>开票信息</h3>
            <br>
            <Row>
              <Col span="8">
                <span class="label">企业名称：</span>
                <span class="isblock">{{detailInfo.corpNameTransfer}}</span>
              </Col>
              <Col span="8">
                <span class="label">纳税人识别号：</span>
                <span class="isblock">{{detailInfo.corpTaxId}}</span>
              </Col>
              <Col span="8">
                <span class="label">开票金额：</span>
                <span class="isblock">{{detailInfo.financeServiceAmount | currency}}</span>
              </Col>
            </Row>
            <br>
            <Row>
              <Col span="16">
                <span class="label">地址、电话：</span>
                <span class="isblock">{{detailInfo.corpAddress}}  {{detailInfo.corpPhone}}</span>
              </Col>
            </Row>
            <br>
            <Row>
              <Col span="16">
                <span class="label">开户行及账号：</span>
                <span class="isblock">{{detailInfo.corpBank}}  {{detailInfo.corpBankAccount}}</span>
              </Col>
            </Row>
            <br>
            <Row>
              <Col span="8">
                <span class="label">接收电子邮箱：</span>
                <span class="isblock">{{detailInfo.corpEmailAddress}}</span>
              </Col>
              <Col span="8">
                <span class="label">开票状态：</span>
                <span class="isblock">{{detailInfo.hasRecord ? '已开' : '未开'}}</span>
              </Col>
            </Row>
            <br>
            <Row v-if="detailInfo.hasRecord">
              <Col span="8">
                <span class="label">开票登记人：</span>
                <span class="isblock">{{detailInfo.userNameCreate}}</span>
              </Col>
              <Col span="8">
                <span class="label">开票登记时间：</span>
                <span class="isblock">{{detailInfo.createTimeString}}</span>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button type="primary" @click="invoiceModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Vue from  'vue'
import ajax from "@/libs/ajax"
import config from '@/config/index'
import { disableTimeInput, dateFormat } from '@/libs/util'
import downloadService from '@/libs/download-file'

export default {
  name: 'finance-invoice-query',
  data() {
    return {
      queryParams: {
        startMaturityDate: '',
        endMaturityDate: '',
        hasRecord: 'false'
      },
      loading: false,
      columns: [
        {
          type: 'selection',
          title: '选择',
          width: '50'
        },
        {
          title: "序号",
          type: "index",
          width: 65,
          align: 'center'
        },
        {
          title: "金票编号",
          key: "fkCredit"
        },
        {
          title: "核心企业",
          key: "corpNameCore"
        },
        {
          title: "融资企业",
          key: "corpNameTransfer"
        },
        {
          title: "金票金额",
          key: "maturityAmount",
          render: (h, params) => {
            return h('div', Vue.filter('currency')(params.row.maturityAmount));
          }
        },
        {
          title: "融资费用",
          key: "financeServiceAmount",
          render: (h, params) => {
            return h('div', Vue.filter('currency')(params.row.financeServiceAmount));
          }
        },
        {
          title: "还款日期",
          key: 'redeemTimeString',
          width: 120
        },
        {
          title: "企业名称",
          key: "corpNameTransfer"
        },
        {
          title: "开票金额",
          render: (h, params) => {
            return h('div', Vue.filter('currency')(params.row.financeServiceAmount));
          }
        },
        {
          title: "纳税人识别号",
          key: "corpTaxId"
        },
        {
          title: '开票状态',
          width: 120,
          render: (h, params) => {
            return h('div', params.row.hasRecord ? '已开' : '未开')
          }
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            let btns = []
            btns.push(h('Button', {
              props: {
                type: 'primary'
              },
              on: {
                click: () => {
                  this.detailInfo = {...{}, ...params.row}
                  this.invoiceModal = true
                }
              }
            }, '详情'))
            return h('div', btns)
          }
        }
      ],
      data: [],
      pagecond: {
        count: 0,
        page: 1,
        pageSize: 10
      },
      invoiceArr: [
        {
          label: '已开',
          value: 'true'
        }, {
          label: '未开',
          value: 'false'
        }
      ],
      exportLoading: false,
      selectedItems: [],
      isCheckedAll: false,
      selectedTotalAmount: 0,
      unInvoiceRecordCount: 0,
      unInvoiceRecordTotal: 0,
      invoiceLoading: false,
      invoiceModal: false,
      detailInfo: {},
      canSelectLength: 0 //可选择的开票信息数量
    };
  },
  created() {
    let weekDay = new Date().getDay()
    weekDay = weekDay === 0 ? 7 : weekDay
    this.queryParams.startMaturityDate = dateFormat(new Date().getTime() - (weekDay-1)*24*60*60*1000, 'yyyy-MM-dd')
    this.queryParams.endMaturityDate = dateFormat(new Date().getTime(), 'yyyy-MM-dd')
    this.query();
  },
  methods: {
    changePage (v) {
      this.pagecond.page = v;
      this.query();
    },
    changePageSize (v) {
      this.pagecond.pageSize = v;
      if (this.pagecond.page === 1) {
        this.query(1)        
      }
    },
    query (page) {
      this.loading = true;
      let params = {
        page: page || this.pagecond.page,
        pageSize: this.pagecond.pageSize,
        ...this.queryParams
      }
      ajax.get('/fin/v1/credits/finance/invoice/record/search/list', {
        params: params
      }).then((res) => {
        this.loading = false;
        this.init()
        if (res.code == 0) {
          res.data.datalist.map(item => {
            if (item.hasRecord) {
              item._disabled = item.hasRecord
            } else {
              this.canSelectLength ++
            }
          })
          this.data = res.data.datalist;
          this.pagecond = res.data.pagecond;
          this.unInvoiceRecordCount = res.data.unInvoiceRecordCount;
          this.unInvoiceRecordTotal = res.data.unInvoiceRecordTotal;
        } else {
          this.$Tip.warning({
            content: res.message
          })
        }
      }).catch(err => {
        this.loading = false;
        this.$Tip.error({
          content: err.message
        })
      });
    },
    // 登记开票信息
    invoiceAdd () {
      this.$Tip.confirm({
        content: `<p>确认已选择数据信息（笔数：${this.selectedItems.length}，开票金额：${Vue.filter('currency')(this.selectedTotalAmount)}）已完成开票处理?</p><p>确认后，对应数据的开票状态为‘已开票’</p>`,
        cancelText: '取消',
        okText: '确认',
        onOk: () => {
          ajax.post('/fin/v1/credits/finance/invoice/record/batch/add', this.selectedItems).then(res => {
            if (res.code === '0') {
              this.$Tip.success({
                content: '开票信息登记已成功'
              })
              this.query()
            } else {
              this.$Tip.error({
                content: res.message
              })
            }
          })
        }
      })
    },
    selectItem(selection) {
      this.selectedItems = selection
      this.selectedTotalAmount = 0
      selection.forEach(sel => {
        this.selectedTotalAmount = this.selectedTotalAmount + sel.financeServiceAmount
      })
      this.isCheckedAll = this.selectedItems.length === this.canSelectLength
    },
    // 全选
    selectAll(status) {
      this.$refs.selection.selectAll(status)
    },
    init () {
      this.selectedItems = []
      this.isCheckedAll = false
      this.selectedTotalAmount = 0
      this.canSelectLength = 0
    },
    setDateTime (v, key) {
      this.queryParams[key] = v
    },
    disableTime (time, type) {
      return disableTimeInput(time, type)
    },
    // 导出excel
    exportExcel () {
      let params = {...{}, ...this.queryParams}
      this.exportLoading = true
      ajax.post('/fin/v1/credits/finance/invoice/record/collect/export', params).then(res => {
        this.exportLoading = false
        if (res.code === '0') {
          // 调下载
          if (res.data) {
            downloadService.downloadFile(res.data, '', false)
          } else {
            this.$Tip.warning({
              content: '暂无可导出文件'
            })
          }
        } else {
          this.$Tip.error({
            content: res.message
          })
        }
      }).catch(err => {
        this.exportLoading = false
        this.$Tip.error({
          content: err.message
        })
      })
    }
  },
  computed: {
    beginDateOption () {
      return {
        disabledDate: date => {
          return date && (date.valueOf() > new Date(this.queryParams.endMaturityDate + ' 00:00:00').getTime() ||  date.valueOf() < (new Date(this.queryParams.endMaturityDate).getTime() - 30*24*60*60*1000))
        }
      }
    },
    endDateOption () {
      return {
        disabledDate: date => {
          return date && (date.valueOf() < new Date(this.queryParams.startMaturityDate + ' 00:00:00').getTime() ||  date.valueOf() > (new Date(this.queryParams.startMaturityDate).getTime() + 30*24*60*60*1000))
        }
      }
    }
  },
}; 
</script>
<style lang="less" scoped>
.lh-30 {
  line-height: 30px;
}
.detail-info span.label{
  display: block;
  float: left;
}
.relative{
  position: relative;
}
.isblock{
  display: block;
  margin-left: 110px;
  vertical-align: top;
}
</style>
